module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_04-3ff16b2262b762c8056f9c1858ef5bb6.jpg";